import { Field, InjectedFormProps } from 'redux-form';

import PhoneInputField from 'dashboard/components/FormControls/PhoneInputField';
import { FormAddListItemProps } from 'dashboard/forms/FormAddListItem/FormAddListItem';
import { isRequired, withMessage } from 'lib/utils/formValidation';
import isValidPhone from 'lib/utils/formValidation/isValidPhone';

const validate = {
  phoneNumber: [
    withMessage('The phone number you entered is not valid for the selected country', isValidPhone),
    withMessage('Enter your phone number', isRequired),
  ],
};

const PhoneNumberFields = ({ submitting }: InjectedFormProps<{}, FormAddListItemProps>) => {
  return (
    <>
      <Field
        component={PhoneInputField}
        name='listItemValue'
        id='listItemValue'
        disabled={submitting}
        placeholder='Copy and paste a phone number here'
        validate={validate.phoneNumber}
      />
    </>
  );
};

export default PhoneNumberFields;
